<template>
  <div class="alert-container">
    <b-alert
      v-model="alert.show"
      :variant="alert.type"
      dismissible
      @dismissed="alert.show = false"
      class="mb-3"
    >
      {{ alert.message }}
    </b-alert>
  </div>
</template>

<script>
import { reactive } from "vue";

export const alertState = reactive({
  show: false,
  type: "info", // Available options: 'success', 'danger', 'warning', 'info'
  message: "",
});

export default {
  data() {
    return {
      alert: alertState,
    };
  },
};
</script>

<style>
.alert-container {
  position: fixed;
  top: 100px;
  right: 20px;
  z-index: 1050;
  width: auto;
  max-width: 500px;
}
</style>
